/**
 * The plain-words toggle, shared by both apps/web surfaces.
 *
 * product-concept §11: "a literal-language mode that swaps all playful copy... for
 * precise functional labels... The metaphor layer is skin, never structure." Reuses
 * `settings.literalMode` (the same key the mobile Settings screen uses) rather than
 * inventing web-specific copy for an identical control.
 */
import { useCopy } from '../theme/CopyProvider';
import { useLiteralToggle, useTheme } from '../theme/ThemeProvider';

export function LiteralToggle() {
  const theme = useTheme();
  const { t } = useCopy();
  const [literal, setLiteral] = useLiteralToggle();
  const s = theme.space;
  const c = theme.colours;

  return (
    <button
      type="button"
      onClick={() => setLiteral(!literal)}
      aria-pressed={literal}
      style={{
        minHeight: s.minTarget,
        padding: `0 ${s.md}px`,
        borderRadius: s.radius.pill,
        border: `${s.hairline}px solid ${c.borderStrong}`,
        background: literal ? c.accentSoft : c.surface,
        color: c.text,
        fontFamily: theme.type.family,
        fontSize: theme.type.label.fontSize,
        fontWeight: theme.type.label.fontWeight,
        cursor: 'pointer',
      }}
    >
      {t('settings.literalMode')}
    </button>
  );
}
